(()=>{
function mount(root=document){
  root.querySelectorAll('[data-ll-footer]').forEach(footer=>{
    if(footer.dataset.footerBound)return;
    footer.dataset.footerBound='true';
    const mobile=matchMedia('(max-width:749px)');
    const apply=()=>{
      footer.querySelectorAll('[data-footer-disclosure]').forEach(details=>{
        details.open=!mobile.matches;
        const summary=details.querySelector('summary');
        if(mobile.matches)summary.removeAttribute('tabindex');
        else summary.setAttribute('tabindex','-1');
      });
    };
    footer.querySelectorAll('[data-footer-disclosure] summary').forEach(summary=>summary.addEventListener('click',event=>{if(!mobile.matches)event.preventDefault();}));
    apply();
    mobile.addEventListener('change',apply);
  });
}
mount();
document.addEventListener('shopify:section:load',event=>mount(event.target));
})();
